import { conversationsQueryKeys } from 'api/consts'
import { queryClient } from 'contexts/reactQuery'

export const invalidateConversationsQuery = (query: string) =>
  queryClient.invalidateQueries({
    exact: true,
    queryKey: conversationsQueryKeys.conversationsList(query),
  })

export const invalidateConversationQuery = (id: string) =>
  queryClient.invalidateQueries({
    exact: true,
    queryKey: conversationsQueryKeys.conversationDetails(id),
  })
